import React, { useEffect, useState } from "react";
import { Form, Input, Button, Card, Typography, message, Layout } from "antd";
import { useNavigate } from "react-router-dom";
import logo from "../Assets/images/ldc_logo_new.png";
import axios from 'axios';
import { Config } from "./Common/Config";
import { EyeInvisibleOutlined, EyeTwoTone, EditOutlined } from "@ant-design/icons";

const { Title } = Typography;
const { Header, Footer } = Layout;

function ResetPassword(props) {
    // https://ldcbe.webdezign.uk/reset-password?token=xlKn4UPHHyawrW9pnHJC6RFjHImeUZYXrk8FGeO8EJM1e1CnWTZUfzfGEjgI
    const [loading, setloading] = useState(false)
    const [token, settoken] = useState(null)
    const [messageApi, contextHolder] = message.useMessage();
    const navigate = useNavigate();
    useEffect(() => {
        // setloading(true)
        const urlParams = new URLSearchParams(window.location.search);
        const token = urlParams.get('token');
        // console.log(':::::::::urlParams::::', { urlParams, token })
        if (token) {
            settoken(token)
            // setloading(true)
        } else {
            setloading(false)
        }
    }, [])


    const onFinish = async (values) => {
        // console.log(':::::::value:::::::::', values)
        if (!token) {
            messageApi.error({
                type: 'error',
                content: 'Something went wrong',
            })
            return
        }
        if (!values.password && !values.password_confirmation) {
            messageApi.error({
                type: 'error',
                content: 'Enter password first',
            })
            return
        }
        try {
            let payload = {
                "new_password": values.password,
                "password_confirmation": values.password_confirmation
            }
            // console.log('payload :::', payload)
            let url = `${Config.urlLogin}/api/v1/reset-password/${token}`
            const response = await axios.post(url, payload, {
                headers: {
                    'Content-Type': 'application/json',
                    // 'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })
            // console.log('response:::', response)
            if (response.data.status) {
                messageApi.success({
                    type: 'success',
                    content: response.data.message,
                })
                setTimeout(()=>{
                    navigate('/')
                },1000)
            } else {
                messageApi.error({
                    type: 'error',
                    content: response.data.message,
                })
            }
        } catch (error) {
            console.log('error ResetPassword:::', error)
            localStorage.removeItem('token')
            localStorage.removeItem('userData')
            localStorage.clear()
            // navigate('/')
            messageApi.error({
                type: 'error',
                content: error?.response?.data?.message,
            })
        }
    }




    return (
        <div>
            <Header style={{ background: "#008385", padding: "30px 20px", justifyContent: "center", display: "flex", marginBottom: "40px", alignItems: "center", boxShadow: "0 2px 8px rgba(0,0,0,0.1)" }}>
                <img src={logo} alt="Logo" style={{ height: "40px" }} />
            </Header>
            <div className="flex justify-center items-center min-h-screen bg-gray-50" style={{ display: 'flex', justifyContent: 'center', }}>
                {contextHolder}
                <Card
                    style={{
                        width: "600px", // Adjust card width here
                        padding: "20px",
                        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                        borderRadius: "10px",

                    }}
                >
                    {/* Header */}
                    <div
                        className="text-white text-center py-3"
                        style={{
                            backgroundColor: "#008385",
                            borderTopLeftRadius: 10,
                            borderTopRightRadius: 10,
                            margin: "-20px -20px 20px -20px", // Ensures header aligns with card edges
                            padding: "15px",
                        }}
                    >
                        <Title level={4} className="m-0 text-white" style={{ color: "#fff" }}>
                            Set new password
                        </Title>
                    </div>

                    <Form name="forgetPassword" onFinish={onFinish} layout="vertical">
                        <Form.Item
                            label="Password"
                            name="password"
                            rules={[
                                {
                                    required: true,
                                    message: "Please enter your password!",
                                },
                                {
                                    min: 8,
                                    message: "Password must be at least 8 characters!",
                                },
                                {
                                    validator: (_, value) => {
                                        if (!value || /^(?=.*[A-Z])(?=.*\d).+$/.test(value)) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(
                                            new Error("Password must include at least 1 uppercase letter and 1 number!")
                                        );
                                    },
                                },
                            ]}
                            style={{ marginBottom: 10 }}
                        >
                            <Input.Password placeholder="Enter your password" />
                        </Form.Item>
                        <Form.Item label="Confirm Password" name="password_confirmation" dependencies={['password']} style={{ width: '100%' }} rules={[({ getFieldValue }) => ({
                            required: !!getFieldValue('password'), // Only required if password is entered
                            message: 'Please confirm your password.',
                        }), ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value || getFieldValue('password') === value) {
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error("Passwords do not match!"));
                            },
                        })]} >
                            <Input.Password
                                placeholder="Confirm New Password"
                                autoComplete="password_confirmationNew"
                                iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                            />
                        </Form.Item>

                        <Form.Item>
                            <Button color="#008385" type="primary" htmlType="submit" block className="bg-purple-600" style={{ backgroundColor: "#008385", borderColor: "#008385" }}>
                                Submit
                            </Button>
                        </Form.Item>
                        <div style={{ textAlign: "center", marginBottom: 0, padding: 0, }}>
                            <a style={{ backgroundColor: "#fff", borderColor: "#fff" }} onClick={() => navigate('/')}>
                                Back to Login
                            </a>
                        </div>
                    </Form>
                </Card>

                <Footer style={{
                    textAlign: "center", marginTop: "3%", color: "#ffffff", position: "fixed",
                    bottom: "0",
                    width: "100%", background: "#008385", padding: "10px 0", boxShadow: "0 -2px 8px rgba(0,0,0,0.1)"
                }}>
                    © {new Date().getFullYear()} London Doctor Clinics. All rights reserved.
                </Footer>
            </div>
        </div>
    )
}
// http://localhost:8082/viewLeadIndividual?id=664ee0675df7ef00083bee42&createdBy=amonexapp@tatabluescopesteel.com
export default (ResetPassword)